import React from 'react';
import { INPUT_DIRECTION } from "../../constants/hardCodedConstants";
import GenericTooltip from '../GenericTooltip/GenericTooltip';

const InputDate = ({
  label,
  name,
  value,
  valueDefault = "",
  onChange,
  sectionName,
  min,
  max,
  isRequired,
  isDisabled,
  direction = "row",
  placeholder = `Ingresar ${label}`,
  toolTipText = "",
}) => {
  value = value?.split("T")[0];

  return (
    <div className={`${INPUT_DIRECTION[direction]}`}>
      <label className={`modal-label ${isRequired ? "required" : ""}`}>
        {label}{" "}
        {toolTipText !== "" && <GenericTooltip id={`ficha-edit-${sectionName}-${name}-tooltip`} text={toolTipText} />}
      </label>
      <div className={`black-color ${value ? "" : "highlight-input"}`}>
        <input
          type="date"
          min={min}
          max={max}
          placeholder={placeholder}
          className="form-control"
          name={name}
          onChange={onChange}
          value={value ?? valueDefault}
          disabled={isDisabled}
        />
        <p
          className="ficha-form-input-validation-message"
          id={`ficha-edit-${sectionName}-${name}-validation-message`}
        ></p>
      </div>
    </div>
  );
};

export default InputDate